import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import merge from 'lodash-es/merge';
import { getCommonType } from './store';
import { AuthProvider } from './context/AuthContext';
import { Provider } from 'react-redux';
import WebAppAuth from './web-app-auth';
import { TonicProvider, Box as Wrapper, theme } from '@tonic-ui/react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 5000,
    },
  },
});

const WebAppAuthBootstrap = (props) => {
  const {
    theme: { colorMode, overrides },
  } = useSelector(
    (state) => ({
      theme: getCommonType(state, 'theme'),
    }),
    shallowEqual
  );
  const backgroundColor = {
    light: 'white',
    dark: 'gray:90',
  }[colorMode];
  const color = {
    light: 'black:primary',
    dark: 'white:primary',
  }[colorMode];
  const customTheme = merge(theme, overrides);

  return (
    <TonicProvider theme={customTheme} colorMode={{ defaultValue: 'light', value: colorMode }}>
      <Wrapper
        backgroundColor={backgroundColor}
        color={color}
        fontSize="sm"
        lineHeight="sm"
        height="100%"
        overflow="auto"
        tabIndex="-1"
        {...props}
      >
        <QueryClientProvider client={queryClient}>
          <AuthProvider authProps={props}>
            <WebAppAuth {...props} />
          </AuthProvider>
        </QueryClientProvider>
      </Wrapper>
    </TonicProvider>
  );
};

const WebAppAuthContainer = (props) => {
  return (
    <Provider store={props.store}>
      <WebAppAuthBootstrap {...props} />
    </Provider>
  );
};

export default WebAppAuthContainer;
